import { jsxs as l, jsx as r } from "react/jsx-runtime";
import o from "./accept-terms.module.less.js";
import "react";
import "dayjs";
import "react-i18next";
import "../../../../contexts/global-context.js";
import "motion/react";
import { PrimaryButton as s } from "../../../elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import { Checkbox as d } from "../../checkbox-group/checkbox-group.js";
const B = ({
  title: t,
  termsContent: i,
  onSubmitForm: p,
  isPostingForm: m,
  submitButtonText: e,
  submitButtonLoadingText: c,
  checkboxProps: a
}) => /* @__PURE__ */ l("div", { className: o.wrapper, children: [
  /* @__PURE__ */ r("h5", { className: "mb-0", children: t }),
  i && /* @__PURE__ */ r("div", { children: i }),
  /* @__PURE__ */ r("div", { className: o.checkbox, children: /* @__PURE__ */ r(d, { ...a }) }),
  /* @__PURE__ */ r(
    s,
    {
      label: m ? c : e,
      isLoading: m,
      onClick: p
    }
  )
] });
export {
  B as default
};
